export const Flags = {
  pve:             { id: 1, color: 0x00ff88, hex: '#00ff88', label: 'PvE Zone' },
  resonance_idle:  { id: 2, color: 0x44aaff, hex: '#44aaff', label: 'Resonance Idle' },
}
